import * as d3ns from "/apps/live/water_data/node_modules/d3/src/index.js";
const d3 = { ...d3ns };
export default d3;
